'use client';
import Image from 'next/image';

import { IFirestoreOffer } from '@/src/modules/firestore/offers/offers.interface';
import { IFirestorePromo } from '@/src/modules/firestore/promos/promos.interface';
import { DestinationDetailsOffersItem } from '@/src/components/ui/DestinationDetails/DestinationDetailsOffers/DestinationDetailsOffersItem/DestinationDetailsOffersItem';
import { useDestinationDetailsOffers } from '@/src/components/ui/DestinationDetails/DestinationDetailsOffers/useDestionationDetailsOffers';
import { ApiCallWrapper } from '@/src/components/ui/api-call-wrapper/ApiCallWrapper';
import { Button } from '@/src/components/ui/button';
import { IResolvedDestinationDetailsPlan } from '@/src/utils/pages/destination-details.mapper';
import { IFirestoreZone } from '@/src/modules/firestore/zones/zones.interface';
import { formatVolume } from '@/src/utils/format/volume';
import { ILocaleType } from '@/src/types';
import { IResolvedErrors } from '@/src/utils/collections/errors.mapper';
import { applyDiscount } from '@/src/utils/format/amount';

type IDestinationDetailsOfferProps = {
  zone: IFirestoreZone;
  offers: IFirestoreOffer[];
  promos: Record<string, IFirestorePromo>;
  destination: IResolvedDestinationDetailsPlan;
  locale: ILocaleType;
  errorTexts?: IResolvedErrors | null;
};

export const DestinationDetailsOffers = ({
  zone,
  offers,
  promos,
  destination,
  locale,
  errorTexts,
}: IDestinationDetailsOfferProps) => {
  const {
    selectedOffer,
    handleSelectOffer,
    handleConfirmOffer,
    isLoading,
    error,
    setError,
  } = useDestinationDetailsOffers({ offers, promos, errorTexts });
  return (
    <>
      <ApiCallWrapper isLoading={isLoading} setError={setError} error={error} />
      <div
        className={'flex w-full flex-col gap-3 lg:grid lg:grid-cols-2 lg:gap-5'}
      >
        {offers.map(offer => (
          <DestinationDetailsOffersItem
            key={offer.id}
            offer={offer}
            promo={promos[offer.id]}
            onClick={handleSelectOffer}
            isActive={selectedOffer?.id === offer.id}
            destination={destination}
            locale={locale}
          />
        ))}
      </div>
      <div className={'flex flex-col gap-2'}>
        {destination.customerAssurance.map((item, index) => (
          <div
            className={'flex items-center gap-2'}
            key={item.text + '_' + index}
          >
            {item.icon && (
              <Image
                src={item.icon.icon}
                alt={item.icon.alt || ''}
                height={20}
                width={16}
              />
            )}
            <p className={'text-sm text-gray'}>{item.text}</p>
          </div>
        ))}
      </div>
      <div>
        <Button
          size={'md'}
          className={'w-full font-bold active:bg-primary-dark lg:w-auto'}
          onClick={handleConfirmOffer}
          disabled={!selectedOffer}
        >
          {destination.buttonPayment}, {zone.name}{' '}
          {selectedOffer &&
            formatVolume(
              applyDiscount(selectedOffer, promos[selectedOffer.id]).volume
            )}
        </Button>
      </div>
    </>
  );
};
